import { useSyncExternalStore } from "react";

/**
 * True while the page is on the dark theme (`<html data-theme="dark">`). The
 * app owns the theme; the shell only reads the attribute, so it needs no
 * provider and stays in step however the theme is changed.
 */
export function useDarkTheme(): boolean {
  return useSyncExternalStore(subscribe, readDark, () => false);
}

function readDark(): boolean {
  return document.documentElement.dataset.theme === "dark";
}

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
}
